import React from 'react';
import styles from './TimeControlBadge.module.css';
import { TimeControlType } from '../../services/MMR/types';

interface TimeControlBadgeProps {
  timeControl: TimeControlType;
  rating: number;
  games: number;
  isPlaced: boolean;
  placementGames?: number;  // For showing X/10 progress
}

const TimeControlBadge: React.FC<TimeControlBadgeProps> = ({
  timeControl,
  rating,
  games,
  isPlaced,
  placementGames = 0
}) => {
  const getTimeLabel = () => {
    switch (timeControl) {
      case 'sprint':
        return '1+2';
      case 'standard':
        return '3+4';
      case 'marathon':
        return '10+10';
      default:
        return '—';
    }
  };

  const getLabel = () => {
    return timeControl.charAt(0).toUpperCase() + timeControl.slice(1);
  };

  return (
    <div className={`${styles.badge} ${styles[timeControl]} ${!isPlaced ? styles.unplaced : ''}`}>
      <div className={styles.label}>{getLabel()}</div>
      <div className={styles.time}>{getTimeLabel()}</div>
      <div className={styles.rating}>
        {isPlaced ? rating : <span className={styles.placementProgress}>{placementGames}/10</span>}
      </div>
      <div className={styles.games}>
        {isPlaced ? `${games} ${games === 1 ? 'game' : 'games'}` : 'Placement'}
      </div>
    </div>
  );
};

export default TimeControlBadge;
